export const environment = {
  BASE_URL: process.env.REACT_APP_BASE_URL,
  BASIC_SECURITY: process.env.REACT_APP_BASIC_SECURITY
}